var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"data-preload":[_vm.$options.name]}},[_vm._v("\n  "+_vm._s(_vm.prefixedSubtitle)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }